// A mock function to mimic making an async request for data
export function createUserSession() {
  return new Promise((resolve) => setTimeout(() => resolve({ data: 7 }), 500));
}
